import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {FITHLayerConfig} from "../stage/FITHLayerConfig";
import {FITHGameMode} from "../gameMode/FITHGameMode";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class FITHBackground extends StillImageBackground {
    private _bgOverlay: PIXI.Graphics;
    private _fsOverlay: PIXI.Graphics;
    private _fsThemeColorOverlay: PIXI.Graphics;
    private _lamp: PIXI.spine.Spine;

    /**
     * @description To toggle the bgOverlay on and off.
     * @param on
     * @param alpha
     */
    public toggleBgOverlay(on: boolean, alpha: number): void {
        this._bgOverlay.visible = on;
        this._bgOverlay.alpha = alpha;
    }

    /**
     * @description To toggle the fsOverlay on and off.
     * @param on
     * @param alpha
     */
    public toggleFSOverlay(on: boolean, alpha: number): void {
        this._fsOverlay.visible = on;
        this._fsOverlay.alpha = alpha;
    }

    public enterFS(): void {
        this.updateFSThemeColorOverlay();
        this._fsThemeColorOverlay.visible = true;
    }

    public exitFS(): void {
        this._fsThemeColorOverlay.visible = false;
        this._fsThemeColorOverlay.clear();
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        this._lamp = new PIXI.spine.Spine(GameResources.getSpineAsset("lamp"));
        this._lamp.position.set(835, 145);
        this.addChild(this._lamp);

        // overlay which is just on top of bg.
        this._bgOverlay = new PIXI.Graphics();
        this._layer.addChild(this._bgOverlay);

        // overlay which is just below FS intro and outro(and logo) screen but is on top of all other items.
        const fsLayer: ScalableLayer = StageManager.getLayer(FITHLayerConfig.FREESPIN.name);
        this._fsOverlay = new PIXI.Graphics();
        fsLayer.addChildAt(this._fsOverlay, 0);

        // overlay which is just on top of bg and played only in FS.
        this._fsThemeColorOverlay = new PIXI.Graphics();
        this._fsThemeColorOverlay.visible = false;
        this._layer.addChild(this._fsThemeColorOverlay);
    }

    /**
     * @inheritDoc
     */
    protected onResize(resizeData: IResizeData): void {
        super.onResize && super.onResize(resizeData);

        if (NolimitApplication.isLandscape) {
            this._lamp.state.clearTracks();
            this._lamp.state.setAnimation(0, "base", true);
            this._lamp.updateTransform();
            this._lamp.visible = true;
        } else {
            this._lamp.state.clearTracks();
            this._lamp.visible = false;
        }

        this.updateBgOverlay();
        this.updateFSOverlay();

        if (this._fsThemeColorOverlay.visible) {
            this.updateFSThemeColorOverlay();
        }
    }

    protected onChangeBackground(data: IGameModeChangedData): boolean {
        const retVal: boolean = super.onChangeBackground(data);

        // #257
        this._backgroundSprite.texture = ImgLoader.getImgTexture("introBg");

        this.updateBgOverlay();
        this.updateFSOverlay();

        if (data.newMode === FITHGameMode.BONUS) {
            this.enterFS();
        }

        return retVal;
    }

    private updateBgOverlay(): void {
        this._bgOverlay.clear();

        this._bgOverlay.beginFill(0x000000, 1);
        this._bgOverlay.drawRect(-480, -480, this._backgroundSprite.width, this._backgroundSprite.height);
        this._bgOverlay.endFill();
        this._bgOverlay.visible = false;
    }

    private updateFSOverlay(): void {
        this._fsOverlay.clear();

        this._fsOverlay.beginFill(0x000000, 1);
        this._fsOverlay.drawRect(-480, -480, this._backgroundSprite.width, this._backgroundSprite.height);
        this._fsOverlay.endFill();
        this._fsOverlay.visible = false;
    }

    private updateFSThemeColorOverlay(): void {
        this._fsThemeColorOverlay.clear();

        this._fsThemeColorOverlay.beginFill(0x210015, 1);
        this._fsThemeColorOverlay.drawRect(-480, -480, this._backgroundSprite.width, this._backgroundSprite.height);
        this._fsThemeColorOverlay.endFill();
        this._fsThemeColorOverlay.alpha = 0.4;
    }
}